<template>
  <AlertMessage
    v-if="!isLoading && !isUnlimitedEngageCredits"
    class="tw:p-2!"
    :type="alertType"
  >
    <i18n-t
      v-if="shouldShowCapAlert"
      keypath="social_engage_account_limit_alert.exhausted"
      scope="global"
      tag="div"
    >
      <template #contact>
        <a
          :class="[alertType, 'tw:underline']"
          :href="`mailto:${contact}`"
          rel="noopener noreferrer"
          target="_blank"
        >
          {{ contactLabel }}
        </a>
      </template>
    </i18n-t>
    <div v-else>
      {{
        $t("social_engage_account_limit_alert.connection_remaining", {
          count: differenceInQuota,
        })
      }}
    </div>
  </AlertMessage>
</template>

<script>
import { storeToRefs } from "pinia";

import { getLocaleText } from "shared/boot/i18n";
import { AlertMessage } from "shared/components/base";
import useFeatureWithCredits from "shared/composables/useFeatureWithCredits";
import { useGlobalStore } from "shared/stores/global";
import { useUserStore } from "shared/stores/user";

export default {
  name: "SocialEngageAccountLimitAlert",
  components: { AlertMessage },
  setup() {
    const {
      engageAccountQuota,
      getCredits,
      integrationCount,
      isUnlimitedEngageCredits,
      remainingQuota,
      shouldShowCapAlert,
      socialIntegrationsStoreRefreshedAt,
    } = useFeatureWithCredits();

    const userStore = useUserStore();
    const { organisation } = storeToRefs(userStore);
    const { appConfig, isStreem } = storeToRefs(useGlobalStore());

    return {
      appConfig,
      isStreem,
      engageAccountQuota,
      getCredits,
      isUnlimitedEngageCredits,
      organisation,
      remainingQuota,
      shouldShowCapAlert,
      socialIntegrationsStoreRefreshedAt,

      currentAccountCount: integrationCount,
      accountQuota: engageAccountQuota,
    };
  },
  data: () => ({
    isLoading: true,
  }),
  computed: {
    alertType() {
      return this.shouldShowCapAlert ? "warning" : "info";
    },
    differenceInQuota() {
      return this.accountQuota - this.currentAccountCount;
    },
    contact() {
      if (this.isStreem) return this.appConfig.emails.streemSocial;

      return this.organisation.account_manager.email;
    },
    contactLabel() {
      return getLocaleText(
        "social_engage_account_limit_alert.exhausted_contact"
      );
    },
  },
  watch: {
    socialIntegrationsStoreRefreshedAt: {
      handler() {
        if (this.isLoading) return;

        this.getCredits();
      },
    },
  },
  async mounted() {
    await this.getCredits();
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
.warning {
  color: $ds-orange-5;
}

.info {
  color: $ds-blue-6;
}
</style>
